var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store-setting-body"},[_c('ul',{staticClass:"store-setting-header"},[_c('span',[_c('i',{staticClass:"el-icon-back",on:{"click":_vm.goBack}})]),_vm._l((_vm.urlMaps),function(item){return _c('li',{key:item.url,class:{ active : _vm.active === item.url }},[_vm._v(_vm._s(item.name))])})],2),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }